// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import classNames from 'classnames';

export default class TextInput extends Component {

  static defaultProps = {
    isRequired: false,

    type: 'text',

    readOnly: false,

    onChange: () => { console.error('TextInput onChange not specified'); },

    onBlur: () => {},

    max: 0,

    error: false,

    inputRef: null,
  };

  static propTypes = {
    value: PropTypes.string,

    onChange: PropTypes.func,

    onBlur: PropTypes.func,

    className: PropTypes.string,

    isRequired: PropTypes.bool,

    type: PropTypes.string,

    readOnly: PropTypes.bool,

    max: PropTypes.number,

    onMaxReached: PropTypes.func,

    error: PropTypes.bool,

    inputRef: PropTypes.func,
  };

  onChange = (event: Event) => {
    const value = event.target.value;
    const { type, max, onMaxReached } = this.props;

    if (type !== "number" && max !== 0 && value.length > max) {
      if (_.isFunction(onMaxReached)) {
        onMaxReached();
      }
    } else {
      this.props.onChange(value, event);
    }
  }

  render() {
    const { isRequired, value, max, type } = this.props;

    const className = classNames('form-control', this.props.className, {
      'read-only': this.props.readOnly,
      'error': this.props.error,
    });

    return (
      <span className="text_input">
        <input
          {...this.props}
          ref={this.props.inputRef}
          type={type}
          onChange={this.onChange}
          onBlur={this.props.onBlur}
          value={value || ''}
          className={className}
          required={isRequired === true ? "required" : ""}
          readOnly={this.props.readOnly}
        />
        {type !== "number" && max !== 0 &&
          <div
            className="text_input__counter"
          >
            {value.length} / {max}
          </div>
        }
      </span>
    );
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/TextInput.js